export default {
  ru: {
    title: 'Подробнее о&nbsp;тарифах',
    tabs: {
      professional: 'Профессиональный',
      pro: 'Про',
      maximum: 'Максимальный',
      max: 'Макс',
      enterprise: 'Премьер',
    },
    slider: {
      _pre: 'Листать обзор преимуществ',
      prev: 'Предыдущий',
      next: 'Следующий',
      img: 'Иллюстрация',
      action: 'Оставить заявку',
    },
    tariffs: {
      professional: [
        '<span class="highlight">Весь набор инструментов</span> для&nbsp;спасения от&nbsp;ежедневной рутины',
        '<span class="highlight">Полный контроль подбора</span> с&nbsp;глубокими отчетами и&nbsp;детализацией по&nbsp;кандидатам',
        '<span class="highlight">Отдельные воронки</span> для&nbsp;каждой категории вакансий',
        '<span class="highlight">Без ограничений:</span> рабочие места для&nbsp;заказчиков бесплатно',
        '<span class="highlight">Без ограничений:</span> количество резюме в&nbsp;вашей базе',
        '<span class="highlight">Контроль сроков</span> прохождения кандидатов по&nbsp;воронке',
        '<span class="highlight">API для&nbsp;любых интеграций</span> с&nbsp;вашими внутренними системами',
        '<span class="highlight">Темы оформления</span> Хантфлоу под ваш вкус и&nbsp;настроение',
      ],
      maximum: [
        '<span class="highlight">Максимальные возможности автоматизации</span> и&nbsp;все передовые новинки',
        '<span class="highlight">Контроль удовлетворенности</span> заказчиков с&nbsp;оценкой по&nbsp;методике NPS',
        '<span class="highlight">Конструктор опросов для тестовых заданий</span> и&nbsp;сбора информации от&nbsp;кандидатов',
        '<span class="highlight">Мультивакансия:</span> уникальный инструмент для&nbsp;вакансий с&nbsp;общей начальной частью воронки',
        // '<span class="highlight">Инструменты</span> для&nbsp;организации работы больших отделов подбора',
        '<span class="highlight">Оповещения о&nbsp;массовом скачивании</span> резюме для&nbsp;контроля безопасности',
        '<span class="highlight">Отчет по&nbsp;движению кандидатов</span> для&nbsp;ежедневного контроля работы рекрутеров',
      ],
      enterprise: [
        '<span class="highlight">100+ проектов</span> реализованных<br> в&nbsp;среднем за&nbsp;3&nbsp;месяца',
        '<span class="highlight">Инструменты для организации работы</span><br> больших отделов подбора',
        '<span class="highlight">Проведение воркшопа для составления</span> оптимального плана внедрения Хантфлоу',
        '<span class="highlight">Индивидуальные IT-решения</span> (Private Cloud, <span class="nowrap">On-premise</span>, SSO, зеркало, доступ к&nbsp;БД)',
        '<span class="highlight">Приоритетная</span> расширенная<br> техподдержка рекрутеров',
      ],
    },
  },
  en: {
    title: 'Learn more',
    tabs: {
      professional: 'Professional',
      pro: 'Pro',
      maximum: 'Maximum',
      max: 'Max',
      enterprise: 'Premier',
    },
    slider: {
      _pre: 'Scroll through the benefits',
      prev: 'Previous',
      next: 'Next',
      img: 'Illustration',
      action: 'Request a&nbsp;demo',
    },
    tariffs: {
      professional: [
        '<span class="highlight">All the tools</span> you need to&nbsp;escape the <span class="nowrap">day-to-day</span> routine',
        '<span class="highlight">Complete recruitment</span> control with <span class="nowrap">in-depth</span> reports and with breakdown by&nbsp;candidate',
        '<span class="highlight">Separate pipelines</span> for each<br> vacancy type',
        '<span class="highlight">Unlimited:</span> workplaces for hiring managers and number of&nbsp;CVs in&nbsp;the database',
        '<span class="highlight">Unlimited:</span> the number<br> of&nbsp;CVs in&nbsp;your database',
        '<span class="highlight">Control the time</span> candidates<br> spend at&nbsp;each stage',
        '<span class="highlight">API for any integrations</span> with<br> your internal systems',
        '<span class="highlight">Interface skins</span> to&nbsp;suit your<br> taste and mood',
      ],
      maximum: [
        '<span class="highlight">Full access to&nbsp;Huntflow features</span> and all <span class="nowrap">cutting-edge</span> updates',
        '<span class="highlight">Hiring managers satisfaction control</span> with NPS scores',
        '<span class="highlight">Survey builder for test assignments</span> and&nbsp;gathering candidate information',
        '<span class="highlight">Multivacancy:</span> a&nbsp;unique tool for vacancies with a&nbsp;common initial stages of&nbsp;the pipeline',
        // '<span class="highlight">Tools</span> for organizing large recruitment departments: assignment to&nbsp;divisions and teams',
        '<span class="highlight">Large scale resume download alerts</span> for security control',
        '<span class="highlight">Candidate movement report</span> for daily control of&nbsp;recruiters&rsquo; work',
      ],
      enterprise: [
        '<span class="highlight">100+ projects</span> completed within<br> 3 months on average',
        'Recruitment tools <span class="highlight">for large</span><br> HR teams',
        '<span class="highlight">A workshop to come up with an optimal</span> implementation plan for Huntflow',
        '<span class="highlight">Customized tech solutions</span> (Private Cloud, <span class="nowrap">On-premise</span>, SSO, mirror, database access)',
        '<span class="highlight">Privilege tech support</span><br> for recruiters',
      ],
    },
  },
};
